import { createContext } from "react";

import { createContextHook } from "~/hooks/createContextHook";
import { type Analytics } from "./AnalyticsType";

export const AnalyticsContext = createContext<Analytics | undefined>(undefined);

export const useAnalytics = createContextHook(
  AnalyticsContext,
  "AnalyticsContext",
);
